import { initPage } from '../../../src/js/core/page.js'
import { TimelineMax, Power2 } from 'gsap/all'

export class Loader {
  constructor () {
    this.loader = document.querySelector('.js-loader')
    this.globe = document.querySelector('.js-globe')
    this.beforeAfterHeader = document.querySelector('.js-before-after-header')

    if (this.globe || this.beforeAfterHeader) {
      this.background = document.querySelector('.js-background')
      this.overlay = document.querySelector('.js-overlay')
      this.logo = document.querySelector('.js-logo')
      this.logoBackground = document.querySelector('.js-logo-background')
      this.logoFill = document.querySelector('.js-logo-fill')
      this.scale = 300
      this.timeUnit = 0.4

      this.init()
    } else {
      this.loader.parentNode.removeChild(this.loader)
      initPage()
      return false
    }
  }

  init = () => {
    this.createTimeline()
    this.timeline.restart()
  }

  createTimeline = () => {
    this.timeline = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.loader.parentNode.removeChild(this.loader)
      }
    })

    this.timeline
      .set(this.logoFill, { webkitClipPath: 'inset(100% 0 0 0)', opacity: 1 })
      .to(this.logoFill, { duration: 0.5, webkitClipPath: 'inset(0% 0 0 0)', ease: Power2.easeInOut }, 'a')
      .to(this.logo,  { duration: this.timeUnit, y: -6, opacity: 0, ease: Power2.easeIn }, 'b')
      .set(this.logo, { y: 6 })
      .set([this.logoFill, this.logoBackground], { fill: '#FFFFFF' })
      // .to(this.logo, { duration: this.timeUnit, y: 0, opacity: 1, ease: Power2.easeOut })
      // .to(this.overlay, { duration: this.timeUnit * 2, y: 0, ease: Power2.easeInOut }, 'b')
      .add(() => {
        initPage()
      })
      // .to(this.logo, { duration: this.timeUnit, y: -6, opacity: 0, ease: Power2.easeIn }, 'c')
      .to([this.background, this.overlay], { duration: this.timeUnit * 2.5, y: '-100%', ease: Power2.easeInOut }, 'c')
  }
}
